const API_BASE = "https://recesso-worker.integrasalus-recesso.workers.dev";

const step1 = document.getElementById("recesso-step-1");
const step2 = document.getElementById("recesso-step-2");
const step3 = document.getElementById("recesso-step-3");
const errBox = document.getElementById("recesso-errore");

let currentOrder = null;

document.getElementById("recesso-verifica-form").addEventListener("submit", async (e) => {
  e.preventDefault();
  errBox.hidden = true;

  const order_number = document.getElementById("order_number").value.trim();
  const email = document.getElementById("email").value.trim();

  try {
    const res = await fetch(`${API_BASE}/api/recesso/verifica`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ order_number, email })
    });
    const data = await res.json();

    if (!data.success) {
      errBox.textContent = data.message || "Ordine non trovato o dati non corretti.";
      errBox.hidden = false;
      return;
    }

    if (!data.order.eligible) {
      errBox.textContent = `Il periodo di recesso per questo ordine è scaduto (scadenza: ${data.order.deadline}).`;
      errBox.hidden = false;
      return;
    }

    currentOrder = data.order;
    document.getElementById("hidden_order_number").value = order_number;
    document.getElementById("hidden_email").value = email;
    document.getElementById("recesso-scadenza-info").textContent =
      `Hai tempo fino al ${data.order.deadline} (${data.order.days_left} giorni rimanenti).`;

    const fieldset = document.getElementById("recesso-prodotti");
    fieldset.innerHTML = "";
    data.order.products.forEach(p => {
      const label = document.createElement("label");
      label.innerHTML = `<input type="checkbox" name="prodotti" value="${p.line_item_id}"> ${p.title} (x${p.quantity})`;
      fieldset.appendChild(label);
    });

    step1.hidden = true;
    step2.hidden = false;
  } catch (err) {
    errBox.textContent = "Errore di connessione, riprova tra qualche istante.";
    errBox.hidden = false;
  }
});

document.getElementById("recesso-dettagli-form").addEventListener("submit", async (e) => {
  e.preventDefault();
  const form = e.target;
  const prodotti = [...form.querySelectorAll('input[name="prodotti"]:checked')].map(i => i.value);

  if (prodotti.length === 0) {
    alert("Seleziona almeno un prodotto da restituire.");
    return;
  }

  const payload = {
    order_number: form.order_number.value,
    email: form.email.value,
    nome: form.nome.value,
    cognome: form.cognome.value,
    line_item_ids: prodotti
  };

  const res = await fetch(`${API_BASE}/api/recesso/invia`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });
  const data = await res.json();

  if (data.success) {
    document.getElementById("recesso-email-conferma").textContent = payload.email;
    step2.hidden = true;
    step3.hidden = false;
  } else {
    alert(data.message || "Errore durante l'invio della richiesta.");
  }
});